export {GenericModule} from './generic.module';
export {GenericListComponent} from './list/generic-list.component';
export {GenericFormComponent} from './form/generic-form.component';
export {GenericService} from './generic.service';
